import { Download, X } from 'lucide-react';
import { pitchClass, INTERVAL_SHORT } from '@/lib/pitch';
import { DEGREE_LABELS } from '@/lib/scales';
import { chordName } from '@/lib/droneChords';

const DIR_LABEL = { up: 'sopra', down: 'sotto', mixed: 'misti' };
const shortOf = (s) => (s === 12 ? 'P8' : INTERVAL_SHORT[s]);

export const SharedExerciseBanner = ({ shared, flats, onAccept, onDismiss }) => {
  const { drone, scale, trainer, click } = shared;
  const root = pitchClass(drone.pc, flats);
  return (
    <section data-testid="tuner-shared-exercise" className="rounded-2xl border border-sky-400/40 bg-sky-400/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sky-300">Esercizio condiviso</div>
        <div data-testid="tuner-shared-exercise-name" className="font-bebas text-2xl tracking-wide truncate">{scale ? `${root} ${scale.name}` : `Intervalli su ${root}`}</div>
        <div className="text-xs font-mono text-white/60">
          Bordone {root}{drone.octave}{drone.fifth ? ' + quinta' : ''} · {drone.temperament === 'just' ? 'Intonazione naturale' : 'Temperamento equabile'}
        </div>
        {scale && <div className="text-xs font-mono text-white/45">{scale.steps.map((s) => DEGREE_LABELS[s]).join(' ')}</div>}
        {trainer && (
          <div data-testid="tuner-shared-exercise-trainer" className="text-xs font-mono text-white/45">
            Intervalli {trainer.intervals.map(shortOf).join(' ')} · {DIR_LABEL[trainer.direction]}
            {trainer.inScale && scale ? ' · solo in scala' : ''}
            {trainer.timed ? ` · ${trainer.barsPer} batt.` : ''}
          </div>
        )}
        {shared.song && <div data-testid="tuner-shared-exercise-song" className="text-xs font-mono text-white/45">Accordi {shared.song.steps.map((s) => chordName(s.pc, s.quality, flats)).join(' – ')}</div>}
        {click && <div data-testid="tuner-shared-exercise-click" className="text-xs font-mono text-white/45">Click {click.bpm} BPM · {click.sig}</div>}
      </div>
      <div className="flex gap-2">
        <button data-testid="tuner-shared-exercise-accept" onClick={onAccept} className="h-11 px-4 rounded-full bg-sky-400 text-black text-xs font-semibold uppercase tracking-[0.2em] inline-flex items-center gap-2 active:scale-95 transition-transform">
          <Download className="w-4 h-4" /> Apri
        </button>
        <button data-testid="tuner-shared-exercise-dismiss" aria-label="Ignora" onClick={onDismiss} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5">
          <X className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};
